import styles from './Navigation.module.scss';
import {Icon, TooltipHost} from '@fluentui/react';
import {NavLink} from 'react-router-dom';
import {useNavigation} from './useNavigation';
import {useContext, useEffect, useMemo, useState} from 'react';
import {GlobalSettingsContext} from '../../../providers/GlobalSettingsContext';
import {MyTaskModal} from '../../Pages/MyTask';
import {TaskContext} from '../../../providers/TaskContext';
import { ChatBotModal } from '../../Pages/ChatBot/ChatBotModal';

export const Navigation = () => {
  const {
    isUserAdmin,
    isUserContributor,
    isHomeUnitCurrent,
    isHomeUnitSelected,
    favUnitUrl,
    setShowChatbot,
    hideIcon,
    logout
  } = useNavigation();
  const context = useContext(TaskContext);
  const {state, refresh} = context || {};
  const {globalSettings} = useContext(GlobalSettingsContext);
  const [showBubble, setShowBubble] = useState(false);
  const [isMyTaskModalOpen, setIsMyTaskModalOpen] = useState(false);


  const chatbotFlag = useMemo(() => {
    return globalSettings.settings.chatbot === 'true';
  }, [globalSettings]);

  const contactUs = (): string => {
    if (!globalSettings.settings.contactUs) {
      return '';
    }
    if (!globalSettings.settings.contactUs.startsWith('http')) {
      return `https://${globalSettings.settings.contactUs}`;
    }

    return globalSettings.settings.contactUs;
  };

  useEffect(() => {
    if (!hideIcon || !chatbotFlag) {
      return;
    }
    const hasSeenBubble = sessionStorage.getItem('top-chatbot-bubble-seen');
    if (hasSeenBubble) {
      return;
    }
    setShowBubble(true);
    sessionStorage.setItem('top-chatbot-bubble-seen', 'true');
    const timer = setTimeout(() => {
      setShowBubble(false);
    }, 10000);

    return () => clearTimeout(timer);
  }, [chatbotFlag, hideIcon]);

  const closeModal = async () => {
    setIsMyTaskModalOpen(false);
    if (refresh) {
      await refresh();
    }
  };

  const handleCloseChatBotTooltip = () => {
    setShowBubble(false);
  };

  return (
    <div className={styles.navigation}>
      {chatbotFlag ? (
        <TooltipHost content={showBubble ? '' : 'Chatbot'}>
          <div className={styles.chatbotContainer}>
            {showBubble && (
              <div className={styles.bubble}>
                I'll still be here <br />
                whenever you need me.
                <button onClick={handleCloseChatBotTooltip}>×</button>
              </div>
            )}
            <div className={styles.chatbotIcon}>
              <Icon
                iconName="ChatBot"
                onClick={() => {
                  setShowBubble(false);
                   setShowChatbot(true);
                 // setIsOpenModal(true);
                }}
              />
            </div>
          </div>
        </TooltipHost>
      ) : null}
      <TooltipHost content={'My Tasks'}>
        <div
          className={styles.container}
          onClick={() => {
            setIsMyTaskModalOpen(true);
          }}>
          <Icon iconName="AlarmClock" />
          {state && state.count > 0 && <span className={styles.badge}>{state.count}</span>}
        </div>
      </TooltipHost>
      {contactUs() ? (
        <TooltipHost content={'Contact us'}>
          <a href={contactUs()} target="_blank" rel="noreferrer">
            <Icon iconName="Headset" />
          </a>
        </TooltipHost>
      ) : null}
      <TooltipHost content={'Help/Manual'}>
        <a
          href={'https://pdc.abb.com/sites/ims/Help/Forms/AllItems.aspx'}
          target="_blank"
          rel="noreferrer">
          <Icon iconName="Help" />
        </a>
      </TooltipHost>
      {isUserAdmin || isUserContributor ? (
        <TooltipHost content={'Admin/Contributor Panel'}>
          <NavLink to={'/admin'} className={({isActive}) => (isActive ? styles.active : '')}>
            <Icon iconName="Admin" />
          </NavLink>
        </TooltipHost>
      ) : null}
      {isHomeUnitSelected ? (
        !isHomeUnitCurrent ? (
          <TooltipHost content={'Go to my home unit'}>
            <NavLink to={favUnitUrl} className={({isActive}) => (isActive ? styles.active : '')}>
              <Icon iconName="Pinned" style={{color: 'red'}} />
            </NavLink>
          </TooltipHost>
        ) : (
          <TooltipHost content={'My home unit'}>
            <NavLink
              to={favUnitUrl}
              className={({isActive}) => `${styles.myUnit} ${isActive ? styles.active : ''}`}>
              <Icon iconName="PinnedSolid" />
            </NavLink>
          </TooltipHost>
        )
      ) : (
        <></>
      )}
      <TooltipHost content={'Logout'}>
        <NavLink to={'#'} onClick={logout}>
          <Icon iconName="Leave" />
        </NavLink>
      </TooltipHost>
      <MyTaskModal isOpenModal={isMyTaskModalOpen} closeModal={closeModal} />
    </div>
  );
};
